<script setup lang="ts">
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'

withDefaults(
  defineProps<{
    darkMode?: boolean | 'auto'
    /**
     * The number of cells to display.
     */
    cells: number
  }>(),
  {
    darkMode: 'auto',
  },
)
</script>

<script lang="ts">
export default {}
</script>

<template>
  <OzBox class="py-1" :color="OzBoxColors.Secondary" :dark-mode="darkMode">
    <template v-for="index of cells">
      <div :key="index" class="h-12" />
      <OzDivider
        v-if="index < cells"
        :key="`divider-${index}`"
        class="mx-5 mt-[-0.5px]"
        :color-scheme="OzDividerColorScheme.Solid"
        :dark-mode="darkMode"
      />
    </template>
  </OzBox>
</template>
